// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__WcEOt","col":"CardReaderDesc_col__2lUcD","label":"CardReaderDesc_label__2znrk"};